enum NavigationButton {
    Email,
    Files,
    Calendar,
    Members,
}

export default NavigationButton;
